<script setup lang="ts">
import { computed, onMounted } from "vue";
import { useI18n } from "vue-i18n";

import type { WidgetApi, WidgetMethods, WidgetSettings } from "@/shared/config";

import { useStartTradeIn } from "@/features/start-trade-in/model";
import { provideWidgetContext } from "@/shared/config";
import { useGlobalStore } from "@/shared/model";
import { WidgetContainer } from "@/widgets/widget-container/ui";

// Direct file import: the model index also re-exports mount(), which imports this component
import { componentsBySteps } from "../model";

// Props are set once on mount and never change afterwards
const { settings, api } = defineProps<{
    settings: WidgetSettings;
    api: WidgetApi;
}>();

provideWidgetContext({ settings, api });

useI18n({ useScope: "global" }).locale.value = settings.locale;

const globalStore = useGlobalStore();

const currentStepComponent = computed(() => componentsBySteps[globalStore.currentStep]);

// Vue copies the exposed API of the custom element root onto the <b2b-widget> element itself
defineExpose({
    tradeIn: useStartTradeIn(),
} satisfies WidgetMethods);

onMounted(() => {
    api.onLoad?.();
});
</script>

<template>
    <WidgetContainer>
        <component :is="currentStepComponent" v-if="currentStepComponent" />
    </WidgetContainer>
</template>

<style src="../styles/base.css"></style>
